import { ReactNode } from 'react'
import { Tree, TreeProps } from 'antd'
import type { DataNode } from 'antd/es/tree'

import { Icon } from 'Shared/atoms'

import { HIERARCHY_BLOCK_HEIGHT } from 'Portals/Internal/Components/DraggableCompanyHierarchy/DraggableHierarchy/constants'

import styles from './styles.module.scss'

interface HierarchyProps<T> extends TreeProps {
	data: T[]
	titleRender?: (node: T) => ReactNode
}

function Hierarchy<T extends DataNode>({ data, titleRender, ...props }: HierarchyProps<T>) {
	return (
		<Tree
			{...props}
			className={styles.hierarchy}
			blockNode
			treeData={data}
			height={HIERARCHY_BLOCK_HEIGHT}
			defaultExpandAll
			switcherIcon={<Icon type="arrowUp" />}
			showLine={{ showLeafIcon: false }}
			showIcon={false}
			titleRender={titleRender ? titleRender : undefined}
		/>
	)
}

export default Hierarchy
